import { Link } from "react-router-dom";
import { Rocket, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
export function StartupHeader() {
  return <div className="flex justify-between items-center mb-8">
      <h1 className="text-4xl font-bold">
        <span className="text-white">Startup</span>{" "}
        
      </h1>
      <div className="flex flex-col gap-3">
        <Link to="/communities/startups/create">
          <Button className="bg-white text-corporate-black hover:bg-corporate-gray-100">
            <Rocket className="w-4 h-4 mr-2" />
            Create Startup
          </Button>
        </Link>
        <Link to="/communities/startups/dashboard">
          <Button className="bg-flux-cyan hover:bg-flux-cyan/80 text-zinc-50 bg-gray-900 hover:bg-gray-800">
            <Building2 className="w-4 h-4 mr-2" />
            My Startups
          </Button>
        </Link>
      </div>
    </div>;
}